import React, { useState, useEffect } from "react";
import EstacionamientoService from "../../services/EstacionamientoService";

import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import myMarkers from "../../puntos_ventas.json"
import mapStyles from "./mapStyles";

function Map() {
  const [selectedPark, setSelectedPark] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [listaLibres, setListaLibres] = useState({});
  useEffect(() => {
    if (!loaded) {
      EstacionamientoService.buscarLugaresLibres( "-34.4597619","-58.9132961")
          .then((resp) => { setListaLibres(resp.data);
          setLoaded(true);
      })
          .catch((error) => { setListaLibres(null);});}
    const listener = e => {
      if (e.key === "Escape") {
        setSelectedPark(null);
      }
    };
    window.addEventListener("keydown", listener);

    return () => {
      window.removeEventListener("keydown", listener);
    };

  }, []);

  

  return ( loaded ? 
    <GoogleMap
      defaultZoom={16.5}
      defaultCenter={{ lat: -34.4588773, lng: -58.9142686 }}
      defaultOptions={{ styles: mapStyles }}
    >
        {listaLibres.extra.sensors.map(park =>  
        
        (
        <Marker
          key={park.nombre}
          position={{
            lat: parseFloat(park.latitud),
            lng: parseFloat(park.longitud),
          }}
          onClick={() => {
            setSelectedPark(park);
          }}
          icon={{
            url: `/estacionamiento-lug-libre-icon.png`,
            scaledSize: new window.google.maps.Size(25, 35)
          }}
        />
      ))}

      {selectedPark && (
        <InfoWindow
          onCloseClick={() => {
            setSelectedPark(null);
          }}
          position={{
            lat: parseFloat(selectedPark.latitud),
            lng: parseFloat(selectedPark.longitud)
          }}
        >
          <div>
            <h2>{selectedPark.externalDeviceId}</h2>
            <p>{selectedPark.internalDevideId}</p>
            <p><a class="buttonMicroClip" href={"https://maps.google.com/?q="+selectedPark.latitud+","+selectedPark.longitud}>Como llegar</a></p>

          </div>
        </InfoWindow>
      )}
    </GoogleMap> : <h1>...</h1>
  );
}

const MapWrapped = withScriptjs(withGoogleMap(Map));

export default function MapaLibres() {
  return (
    <div style={{ width: "100vw", height: "78vh" }}>
      <MapWrapped
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${
          "AIzaSyBauEMXNpAYf2wrK_QcSN2MZca80lWR-vI"
        }`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </div>
  );
}
